<mat-spinner class="spinner" *ngIf="isLoading"></mat-spinner>
<div class="keyboard">
  <div class="keyboard__key keyboard__key__left">
    <div name="number1" class="keyboard__key__div" (click)="setValue($event)">1</div>
  </div>
  <div class="keyboard__key keyboard__key__center">
    <div name="number2" class="keyboard__key__div" (click)="setValue($event)">2</div>
  </div>
  <div class="keyboard__key keyboard__key__right">
    <div name="number3" class="keyboard__key__div" (click)="setValue($event)">3</div>
  </div>
  <div class="keyboard__key keyboard__key__left">
    <div name="number4" class="keyboard__key__div" (click)="setValue($event)">4</div>
  </div>
  <div class="keyboard__key keyboard__key__center">
    <div name="number5" class="keyboard__key__div" (click)="setValue($event)">5</div>
  </div>
  <div class="keyboard__key keyboard__key__right">
    <div name="number6" class="keyboard__key__div" (click)="setValue($event)">6</div>
  </div>
  <div class="keyboard__key keyboard__key__left">
    <div name="number7" class="keyboard__key__div" (click)="setValue($event)">7</div>
  </div>
  <div class="keyboard__key keyboard__key__center">
    <div name="number8" class="keyboard__key__div" (click)="setValue($event)">8</div>
  </div>
  <div class="keyboard__key keyboard__key__right">
    <div name="number9" class="keyboard__key__div" (click)="setValue($event)">9</div>
  </div>
  <div class="keyboard__key keyboard__key__left">
    <div
      name="deletedigit"
      data-testid="deletedigit"
      class="keyboard__key__div keyboard__key__red"
      (click)="delete()"
    >
      <span class="material-icons-outlined keyboard__key__div keyboard__key__red__icon">
        backspace
      </span>
    </div>
  </div>
  <div class="keyboard__key keyboard__key__center">
    <div name="number0" class="keyboard__key__div" (click)="setValue($event)">0</div>
  </div>
  <div class="keyboard__key keyboard__key__right">
    <button
      name="buttonconfirm"
      data-testid="buttonconfirm"
      class="keyboard__key__div keyboard__key__green"
      [disabled]="isLoading || globalIsLoading || disableEnter"
      (click)="confirm()"
    >
      <span class="material-icons-outlined keyboard__key__div keyboard__key__green__icon">
        check
      </span>
    </button>
  </div>
</div>
